module.exports = "/packs/money_logo-fda00907223be542539ffd34ab505643.svg";